import { memo, useEffect, useState } from 'react';
import _ from 'lodash';
import { Biz_Info, ThemeRoutePlaceInfo } from '@/store/types';
import { animated, useTransition } from "@react-spring/web";
import ThemeSpot from './components/ThemeSpot';
import { characterPoints } from '../CharaterRouteVideo/instance';
import styles from './index.module.scss';
import SVGBrokenLine from './components/SVGBrokenLine';
import { useQueryGetAllRouteData } from '@/services/hooks';
import { useStore } from '@/store';
import { getTargetList } from '@/services/api';
import { useQueryGetPlaceJson } from '@/services/hooks';
import QrCode from '@/components/QrCode';
import RouteTimeLine from './components/RouteTimeLine';
import { qrCodeList } from '@/components/QrCode/instance';
import { driveDigitalHumanBySpeak, driveDigitalHumanByText } from '@/pages/DigitalHuman/util/tts-manage';
import { getScenicDataInsights } from '@/services/get';


const ThemeRoute = () => {
  const { data } = useQueryGetAllRouteData();
  const { data: placeData } = useQueryGetPlaceJson();
  const routeDetailId = useStore(state => state.routeDetailId);
  const [totalList, setTotalList] = useState([]);
  const [themeObj, setThemeObj] = useState<any>({ name: '', theme: '', url: '' });
  const [card, setCard] = useState<any>();
  const [character, setCharacter] = useState<any>(null);


  // 语音控制
  useEffect(()=>{
    if(!routeDetailId)return;
    const list = data?.charaterList.concat(data.themeList);
    const target: any = list?.find(item => item.entity_id === routeDetailId);
    // console.log('target',target);
    if(target){
      // const name = target?.content?.split('\n')?.[0] || '';
      // const targetCharacter = characterPoints.find(i => i.name === name);
      // if(targetCharacter){
      //   driveDigitalHumanByText(`我们现在看到的是${target.name || ''}文学路线`);
      // }else{
      //   driveDigitalHumanByText(`我们现在看到的是${target.name || ''}主题路线`);
      // }
      const xihuInsight = getScenicDataInsights(target.biz_info?.scenic_data_insights);
      if(xihuInsight){
        driveDigitalHumanBySpeak(xihuInsight); 
      }

    }else{
      driveDigitalHumanByText('未找到相关路线');
    }
  },[data,routeDetailId])

  useEffect(() => {
    setTotalList([]);
    if (data?.charaterList?.length && data?.themeList?.length && routeDetailId) {
      const list = data.charaterList.concat(data.themeList);
      const target: any = list.find(item => item.entity_id === routeDetailId);
      const obj = qrCodeList.find(i => i.name === target.name);
      if (!target && !obj) return;
      setThemeObj(obj);
      setCard(target);
      const { biz_info, tags } = target;
      const name = target?.content?.split('\n')?.[0] || '';
      const targetCharacter = characterPoints.find(i => i.name === name);
      setCharacter(targetCharacter);
      getList(biz_info, targetCharacter, tags);
    }
  }, [data, placeData, routeDetailId]);

  const transitions = useTransition(character, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 500 },
  });

  const getList = (biz_info: Biz_Info, targetCharacter: any, tags: string[]) => {
    const paramsQuery = biz_info.data.map((i) => `entity_id:${i.id}`).join(' OR ');
    const relParamsQuery = tags.filter(i=>i.startsWith('路线实体')).map(i=>`tags:${i}`).join(' OR ');

    // 根据id查询所有景点数据
    getTargetList(paramsQuery,relParamsQuery).then((res: any) => {
      if (res?.length) {
        const arr: any = biz_info.data.map((item) => {
          const target = res.find((i: any) => i.entity_id === item.id);
          if (target) {
            const position = placeData.find((i: any) => i.name === target.name);
            const newExtNeighborList = target?.ext_neighborList?.filter((i: any) => {
              return tags.some((tag: string) => {
                const hasTag = i.edge?.tags?.includes(tag);
                const isRouteEntity = tag.startsWith('路线实体');
                return hasTag && isRouteEntity;
              });
            });
            if (position) {
              return {
                ...target,
                tour_golden_sentences: item?.tour_golden_sentences,
                ext_neighborList: newExtNeighborList,
                name: item.name,
                order: item?.order,
                time_order: item?.time_order,
                top: position.y,
                left: position.x
              }
            }
          } else {
            return null;
          }
        }).filter((i) => i).sort((a: any, b: any) => b.order - a.order);
        // console.log('缺少景点：', _.differenceBy(res, place, 'name').map((i: any) => i.name));
        if (targetCharacter) {
          arr.unshift({
            content: '',
            entity_id: '',
            ext_neighborList: [],
            image: '',
            left: targetCharacter?.coverPos?.left + targetCharacter?.width / 2,
            top: targetCharacter?.coverPos?.top + 120,
            name: '',
            order: -1,
            tour_golden_sentences: '',
            summary: '',
            time_order: '',
            type: []
          });
        }
        // console.log('arr',arr);
        setTotalList(arr);
      }
    });
  }


  const listTransition = useTransition(totalList, {
    from: { scale: 0, opacity: 0 },
    enter: { scale: 1, opacity: 1 },
    leave: null,
    config: { duration: 300 },
    trail: 500,
  });

  const HighlightNumbers = (text: string) => {
    const parts = text?.split(/(\d+)/).filter(Boolean) || [];
    return (
      <div>
        {parts.map((part, index) => (
          // 如果是数字，则用<span>包裹并应用样式
          <span
            key={index}
            className={`${part.match(/^\d+$/) ? styles.num : ''}`}
          >
            {part}
          </span>
        ))}
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.short_summary}>{HighlightNumbers(card?.short_summary)}</div>
      {
        totalList.length ? <SVGBrokenLine points={totalList} duration={500} /> : null
      }
      {
        transitions((style, item) =>
          item ?
            <animated.div style={style}>
              {
                item?.video ?
                  <video
                    className={styles.character}
                    style={{ width: item.width, top: item.coverPos.top, left: item.coverPos.left }}
                    src={item?.video}
                    autoPlay
                    loop
                  /> :
                  <img
                    className={styles.character}
                    style={{ width: item.width, top: item.coverPos.top, left: item.coverPos.left, height: 214 }}
                    src={item?.image}
                  />
              }
            </animated.div> :
            null
        )
      }
      {
        totalList?.length ?
          listTransition((style, item: ThemeRoutePlaceInfo, _, index) =>
            item?.name ?
              <animated.div
                key={item.entity_id}
                style={{
                  ...style,
                  left: 0,
                  top: 0,
                  position: 'absolute',
                  x: item.left,
                  y: item.top,
                }}
              >
                <ThemeSpot place={item} card={card} />
              </animated.div> :
              null
          ) : null
      }
      {/* {
        list.map((place, index) => (
          <ThemeSpot
            key={place.entity_id}
            place={place}
            index={index}
            card={card}
          />
        ))
      } */}
      <div className={styles.theme}>{themeObj?.theme}</div>
      <RouteTimeLine list={character ? totalList.slice(1) : totalList} />
      <QrCode name={card?.name} />
    </div>
  );
};

export default memo(ThemeRoute); 